import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { Button } from "react-bootstrap";

const Page401 = () => (
  <React.Fragment>
    <Helmet title="401 Error" />
    <div className="text-center">
      <h1 className="display-1 fw-bold">401</h1>
      <p className="h1">Unauthorized.</p>
      <p className="h2 fw-normal mt-3 mb-4">
        This page requires authorization rights.
      </p>
      <p className="h2 fw-normal mt-3 mb-4">
        Please contact the administrator for more details
      </p>
      <Link to="/">
        <Button variant="primary" size="lg">
          Return to website
        </Button>
      </Link>
    </div>
  </React.Fragment>
);

export default Page401;
